<template>
  <Vidle
    :loop="true"
    :reminders="[30]"
    :wait="1"
    :duration="props.timeout"
    :sync-key="props.syncKey"
    @idle="onIdle"
    @remind="onRemind"
  />
</template>

<script lang="ts" setup>
import { watch } from 'vue';
import Vidle from 'v-idle';

const { $toastSuccess, $toastInfo } = useNuxtApp();
const { data: $auth } = useAuth();
const { signOut } = useProfileStore();

const props = withDefaults(
  defineProps<{
    timeout?: number;
    syncKey?: string;
  }>(),
  { timeout: 300, syncKey: '' },
);

// v-idle only reads duration when its countdown restarts, so nudge it to restart with the new value
watch(
  () => props.timeout,
  () => window.dispatchEvent(new MouseEvent('mousemove')),
  { flush: 'post' },
);

const onIdle = async () => {
  $toastSuccess(`🔒 Automatically logged out after ${props.timeout / 60}m of inactivity`);
  localStorage.setItem('snap_is_agent', `${$auth.value?.accountAppType === 2}`);
  await signOut();
};

const onRemind = () => {
  $toastInfo(`🔒 You will be automatically logged out after 30s of inactivity`);
};
</script>
